import { render, staticRenderFns } from "./FixedLayout.vue?vue&type=template&id=ec84a4de&"
import script from "./FixedLayout.vue?vue&type=script&lang=js&"
export * from "./FixedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports